import React, { useState } from 'react';
import PropTypes from 'prop-types';

import useStyles from './styles';
import ComplexTextInput from '../../inputs/ComplexTextInput';
import FilterButton from '../../buttons/FilterButton';


const ControlSearchPanel = ({ onSearch }) => {
  const [searchValue, setSearchValue] = useState('');
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <FilterButton
        onClick={() => { onSearch(searchValue); }}
        className={classes.searchButton}
      />

      <ComplexTextInput
        id="search-value"
        type="search"
        value={searchValue}
        iconName="search"
        onChange={e => { setSearchValue(e.target.value); }}
        onlyFocusHighlight
        altClasses={{
          input: classes.input,
          image: classes.image,
          fixedHeight: classes.fixedHeight,
        }}
      />
    </div>
  );
};

ControlSearchPanel.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default ControlSearchPanel;
